import cx from 'classnames';

/**
 * Alert component for displaying messages with different severity levels.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {React.ReactNode} [props.children=null] - Content to display inside the alert.
 * @param {string} [props.className=''] - Additional CSS classes for the alert container.
 * @param {Object} [props.error=null] - Optional error object. If it contains a `networkError` property, a network error message is shown.
 * @param {Function} [props.onClose=null] - Callback function invoked when the alert is closed.
 * @param {'warning'|'error'|'info'|'success'} [props.severity='warning'] - Severity level of the alert.
 * @param {string} [props.title='Something went wrong'] - Title text for the alert.
 * @returns {JSX.Element} The rendered alert component.
 */
export default function Alert({
  children = null,
  className = '',
  error = null,
  onClose = null,
  severity = 'warning',
  title = 'Something went wrong',
}) {
  if (error?.networkError) {
    title = 'Network error';
    severity = 'warning';
    children = (
      <p>
        A network error has occurred. Please check your connection or press
        'Reload' in your browser.
      </p>
    );
  }
  return (
    <div
      className={cx(`tw-relative gb-alert gb-alert--${severity}`, className)}>
      {onClose && (
        <button
          className="gb-alert__close tw-absolute tw-top-2 tw-right-2"
          onClick={() => onClose()}>
          Close
        </button>
      )}
      <div className="gb-alert__body">
        <div className="gb-alert__icon">
          <i className={`gb-icon gb-icon-morpheus-${severity}-full`} />
        </div>
        <div className="gb-alert__content">
          <div className="gb-alert__title">{title}</div>
          {children}
        </div>
      </div>
    </div>
  );
}
